<template>
  <div class="aggregation-edit">
    <el-form ref="form" :model="form" :rules="rules" size="small">
      <div class="white-container">
        <el-form-item label="活动标题" prop="name" label-width="100px" style="width: 460px">
          <el-input v-model="form.name" maxlength="14" placeholder="请输入活动标题，最多不超过14个字" />
        </el-form-item>
        <el-form-item label="上传头图" prop="coverImage" label-width="100px" style="width: 460px">
          <UploadImage :show-replace="false" :url="form.coverImage" save-path="ua_activity/aggregation/" title="把汗流漂亮头图" size-tips="750px*370px" @upload="uploader($event,'coverImage')" @triggerReg="handleCheckImg('coverImage')" />
        </el-form-item>
        <el-form-item label="活动报名title" prop="signUpIcon" label-width="100px" style="width: 460px">
          <UploadImage :show-replace="false" :url="form.signUpIcon" save-path="ua_activity/aggregation/" title="默认状态图片" size-tips="148px*60px" class-name="small-upload" @upload="uploader($event,'signUpIcon')" @triggerReg="handleCheckImg('signUpIcon')" />
        </el-form-item>
        <el-form-item label="高光时刻title" prop="highlightMomentIcon" label-width="100px" style="width: 460px">
          <UploadImage :show-replace="false" :url="form.highlightMomentIcon" save-path="ua_activity/aggregation/" title="默认状态图片" size-tips="148px*60px" class-name="small-upload" @upload="uploader($event,'highlightMomentIcon')" @triggerReg="handleCheckImg('highlightMomentIcon')" />
        </el-form-item>
        <div class="flex">
          <el-form-item label="页面背景" prop="backgroundImage" label-width="100px">
            <div class="flex">
              <el-select v-model="backgroundType" placeholder="选择背景类型" style="width:147px;margin-right:10px;" @change="handleChangebgType">
                <el-option label="图片" :value="0" />
                <el-option label="颜色" :value="1" />
              </el-select>
              <UploadImage v-if="backgroundType===0" :show-replace="false" :url="form.backgroundImage" save-path="ua_activity/aggregation/" class-name="small-upload" breadth="750px" @upload="uploader($event,'backgroundImage')" />
              <el-input v-else v-model="form.backgroundColor" placeholder="请输入背景色，如#FFFFFF" style="width:203px" />
            </div>
          </el-form-item>
        </div>
      </div>

      <div class="white-container marginTop">
        <el-form-item label="添加主活动" prop="eventCoverImage" label-width="100px" class="cotent-wrap">
          <UploadImage :show-replace="false" :url="form.eventCoverImage" save-path="ua_activity/aggregation/" title="主活动图片" size-tips="686px*250px" @upload="uploader($event,'eventCoverImage')" />
          <div class="search">
            <el-input v-model.number="mainSearch" class="fix" type="number" placeholder="请输入活动ID" prefix-icon="el-icon-search" style="170px" />
            <el-button type="primary" @click="searchMain">查询</el-button>
            <el-button @click="resetMain">重置</el-button>
          </div>
          <div>
            <el-table v-if="mainSearchList !=undefined" ref="mainSearchTable" class="searchTable" size="small" :data="mainSearchList" style="width: 100%;margin-top:30px;">
              <el-table-column prop="id" label="活动ID" />
              <el-table-column prop="name" label="活动标题" />
              <el-table-column prop="beginTime" label="活动开始日期">
                <template v-slot="{row}">
                  {{ $moment(row.beginTime).format('YYYY/MM/DD') || '--' }}
                </template>
              </el-table-column>
              <el-table-column prop="city" label="活动城市" />
              <el-table-column label="操作">
                <template v-slot="{row}">
                  <el-button v-if="!row.isSelected" size="small" type="text" class="link-color" @click="mainAdd(row)">添加</el-button>
                  <el-button v-else size="small" type="text" disabled style="cursor:not-allowed">已添加</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="spilt-title">已添加活动</div>
            <el-table class="searchTable" size="small" :data="mainSelectList" style="width: 100%">
              <el-table-column prop="id" label="活动ID" />
              <el-table-column prop="name" label="活动标题" />
              <el-table-column prop="beginTime" label="活动开始日期">
                <template v-slot="{row}">
                  {{ $moment(row.beginTime).format('YYYY/MM/DD') || '--' }}
                </template>
              </el-table-column>
              <el-table-column prop="city" label="活动城市" />
              <el-table-column label="操作">
                <template v-slot="{row}">
                  <el-button size="small" type="text" class="link-color" @click="mainDelete(row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </div>
      <div v-for="(item,index) in form.exclusiveActivityAggregationPageAddSeriesEventDTOS" :key="index+item" class="white-container marginTop">
        <div class="card-title">Tab{{ index+1 }}子活动</div>
        <el-form-item :label="`tab${index+1}名称`" label-width="110px" :prop="'exclusiveActivityAggregationPageAddSeriesEventDTOS.'+index+'.seriesName'" :rules="{ required: true, message: '请输入tab名称', trigger: 'blur' }">
          <el-input v-model="item.seriesName" placeholder="请输入tab名称" style="width:360px;" />
        </el-form-item>
        <el-form-item :label="`上传tab${index+1}图片`" label-width="110px" :prop="'exclusiveActivityAggregationPageAddSeriesEventDTOS.'+index+'.seriesUnselectedImage'" :rules="[{ required: true, message: '请上传tab图片', trigger: 'blur' },{validator: checkTabImg, trigger: ['blur','change'] }]">
          <div class="flex">
            <UploadImage :show-replace="false" class-name="small-upload" :url="item.seriesUnselectedImage" save-path="ua_activity/aggregation/" title="默认状态图片" size-tips="212px*60px" @upload="tabUploader($event,'seriesUnselectedImage',index)" />
            <UploadImage :show-replace="false" class-name="small-upload" :url="item.seriesSelectedImage" save-path="ua_activity/aggregation/" title="选中状态图片" size-tips="212px*60px" @upload="tabUploader($event,'seriesSelectedImage',index)" />
          </div>
        </el-form-item>

        <div class="search">
          <el-input v-model.number="tabSearchs[index].search" size="small" class="fix" type="number" placeholder="请输入活动ID" prefix-icon="el-icon-search" style="170px" />
          <el-button size="small" type="primary" @click="searchTab(index)">查询</el-button>
          <el-button size="small" @click="resetTab(index)">重置</el-button>
        </div>
        <div>
          <el-table v-if="tabSearchs[index].hasOwnProperty('tabSearchList') && tabSearchs[index]['tabSearchList'] !== undefined" class="searchTable" size="small" :data="tabSearchs[index]['tabSearchList']" style="width: 100%;margin-top:30px;">
            <el-table-column prop="id" label="活动ID" />
            <el-table-column prop="name" label="活动标题" />
            <el-table-column prop="beginTime" label="活动开始日期">
              <template v-slot="{row}">
                {{ $moment(row.beginTime).format('YYYY/MM/DD') || '--' }}
              </template>
            </el-table-column>
            <el-table-column prop="city" label="活动城市" />
            <el-table-column label="操作">
              <template v-slot="{row}">
                <el-button v-if="!row.isSelected" size="small" type="text" class="link-color" @click="tabAdd(row,index)">添加</el-button>
                <el-button v-else size="small" type="text" disabled style="cursor:not-allowed">已添加</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="spilt-title">已添加活动</div>
          <el-table class="searchTable" size="small" :data="tabSearchs[index]['tabSelectList']" style="width: 100%">
            <el-table-column prop="id" label="活动ID" />
            <el-table-column prop="name" label="活动标题" />
            <el-table-column prop="beginTime" label="活动开始日期">
              <template v-slot="{row}">
                {{ $moment(row.beginTime).format('YYYY/MM/DD') || '--' }}
              </template>
            </el-table-column>
            <el-table-column prop="city" label="活动城市" />
            <el-table-column label="操作">
              <template v-slot="scope">
                <el-button size="small" type="text" class="link-color" @click="tabDelete(scope.$index,scope.row,index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-button v-if="form.exclusiveActivityAggregationPageAddSeriesEventDTOS.length <3" icon="el-icon-plus" style="width:100%;height:80px;margin-top:30px;" @click="addTab">添加tab活动</el-button>

      <el-form-item style="width:100%;margin-top:50px;">
        <div class="flex btns">
          <el-button type="info" @click="cancelBtn">取消</el-button>
          <el-button type="primary" @click="submit">保存</el-button>
        </div>
      </el-form-item>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import { ActivityAggregation } from '@/model/ActivityAggregation';
import UploadImage from '@/components/UploadImage';
import Dialog from '@/components/Dialog';
import { searchActionById, updateAggregation, addAggregation } from '@/api/activity';
import FunctionUtils from "@/utils/functionUtils";

export default {
  components: { UploadImage, Dialog },
  data() {
    return {
      id: '',
      formDialogShow: false,
      backgroundType: 0, // 页面背景类型 0图片 1颜色
      mainSearch: '',
      mainSearchList: undefined, // 主活动筛选的活动
      mainSelectList: [], // 主活动选择的互动
      information: {},
      cancelTxt: '',
      form: new ActivityAggregation(),
      currentIndex: -1,
      tabSearchs: [{
        search: '',
        tabSelectList: [],
      }], // tab的搜索
      rules: {
        name: [
          { required: true, message: '活动主标题', trigger: 'blur' },
        ],
        coverImage: [{ required: true, message: '请上传头图', trigger: ['blur', 'change'] }],
        signUpIcon: [{ required: true, message: '请上传活动报名title', trigger: ['blur', 'change'] }],
        highlightMomentIcon: [{ required: true, message: '请上传高光时刻title', trigger: ['blur', 'change'] }],
      },
    };
  },

  mounted() {
    const { query } = this.$route;
    if (query.id) {
      this.id = query.id;
      console.info('编辑');
      this.cancelTxt = '编辑';
      this.fetchDetail(query.id);
    } else if (query.copyid) {
      console.info('复制');
      this.cancelTxt = '复制';
      this.fetchDetail(query.copyid);
    } else {
      console.info('新增');
      this.cancelTxt = '新增';
    }
  },
  methods: {
    checkTabImg(validate, value, cb) {
      this.form.exclusiveActivityAggregationPageAddSeriesEventDTOS.forEach(item => {
        if (!item.seriesUnselectedImage && !item.seriesSelectedImage) {
          cb(new Error('请上传tab图片'));
        } else if (!item.seriesUnselectedImage) {
          cb(new Error('请上传默认状态图片'));
        } else if (!item.seriesSelectedImage) {
          cb(new Error('请上传选中状态图片'));
        } else {
          cb();
        }
      });
    },
    async searchMain() {
      if (!this.mainSearch) {
        this.$message.warning('请先输入活动ID');
        return;
      }
      const data = await searchActionById(this.mainSearch);
      if (data && data.id) {
        this.mainSearchList = [{ ...data, isSelected: false }];
      } else {
        this.mainSearchList = [];
      }
    },
    resetMain() {
      this.mainSearch = '';
      this.mainSearchList = [];
    },
    async searchTab(index) {
      if (!this.tabSearchs[index].search) return this.$message.warning('请先输入活动ID');
      const data = await searchActionById(this.tabSearchs[index].search);
      const copyList = FunctionUtils.deepClone(this.tabSearchs);
      if (data && data.id) {
        copyList[index]['tabSearchList'] = [{ ...data, isSelected: false }];
      } else {
        copyList[index]['tabSearchList'] = [];
      }
      this.tabSearchs = copyList;
    },
    resetTab(index) {
      const copyList = FunctionUtils.deepClone(this.tabSearchs);
      if (copyList[index].hasOwnProperty('tabSearchList')) {
        copyList[index].tabSearchtList = [];
      }
      copyList[index].search = '';
      this.tabSearchs = copyList;
    },
    // 添加一个tab子活动
    addTab() {
      const id = this.$route.id || this.$route.copyid;
      const copyList = FunctionUtils.deepClone(this.form);
      if (id) {
        copyList.exclusiveActivityAggregationPageAddSeriesEventDTOS.push({
          search: '',
          campaignId: id,
          id: this.exclusiveActivityAggregationPageAddSeriesEventDTOS.length + 1,
          seriesName: '',
          seriesSelectedImage: '',
          seriesUnselectedImage: '',
          tabSelectList: [],
        });
      } else {
        copyList.exclusiveActivityAggregationPageAddSeriesEventDTOS.push({
          search: '',
          seriesName: '',
          seriesSelectedImage: '',
          seriesUnselectedImage: '',
          tabSelectList: [],
        });
      }
      this.form = copyList;
      this.tabSearchs.push({
        search: '',
        tabSelectList: [],
      });
    },
    // tab添加活动
    tabAdd(row, index) {
      const copyList = FunctionUtils.deepClone(this.tabSearchs);
      copyList[index]['tabSearchList'] = [{ ...row, isSelected: true }];
      copyList[index]['tabSelectList'].push({ ...row, isSelected: true });
      this.tabSearchs = copyList;
    },
    tabDelete(i, row, index) {
      const copyList = FunctionUtils.deepClone(this.tabSearchs);
      if (copyList[index]['tabSearchList']) {
        const searchIndex = copyList[index]['tabSearchList'].findIndex(item => item.id === row.id);
        if (searchIndex !== -1) {
          copyList[index]['tabSearchList'][searchIndex].isSelected = false;
        }
      }
      copyList[index]['tabSelectList'].splice(i, 1);
      this.tabSearchs = copyList;
    },
    mainAdd(row) {
      this.mainSearchList = [{ ...row, isSelected: true }];
      this.mainSelectList = [{ ...row, isSelected: true }];
      this.form = {
        ...this.form,
        eventId: row.id,
        eventName: row.name,
        beginTime: row.beginTime,
        city: row.city,
      };
    },
    mainDelete(row) {
      if (this.mainSearchList && this.mainSearchList.length) {
        this.mainSearchList = [{ ...row, isSelected: false }];
      }
      this.form = {
        ...this.form,
        eventId: undefined,
        eventName: undefined,
        beginTime: undefined,
        city: undefined,
      };
      this.mainSelectList = [];
    },
    handleChangebgType(v) {
      this.form.backgroundColor = '';
      this.form.backgroundImage = '';
    },
    uploader(file, key) {
      this.form[key] = file;
    },
    tabUploader(file, key, index) {
      const data = FunctionUtils.deepClone(this.form);
      data.exclusiveActivityAggregationPageAddSeriesEventDTOS[index][key] = file;
      this.form = data;
      this.currentIndex = index;
      this.$refs.form.validateField(`exclusiveActivityAggregationPageAddSeriesEventDTOS.${index}.seriesUnselectedImage`);
    },
    handleCheckImg(type) {
      if (!this.$refs.form) return;
      this.$refs.form.validateField(type);
    },
    submit() {
      this.formDialogShow = true;
      this.information = {
        operation: 'submit',
        icon: 'warn',
        subTitle: "确定保存吗？",
      };
    },
    fetchDetail(id) {
      this.$Api.activity.fetchAggregationDetail(id).then(res => {
        this.form = new ActivityAggregation(res);
        if (res.eventId) {
          this.mainSelectList = [{ id: res.eventId, name: res.eventName || '', beginTime: res.beginTime || '', city: res.city || '', isSelected: true }];
        }
        if (res.exclusiveActivityAggregationPageDetailsSeriesEventVOS && res.exclusiveActivityAggregationPageDetailsSeriesEventVOS.length) {
          this.tabSearchs = res.exclusiveActivityAggregationPageDetailsSeriesEventVOS.map(item => {
            return {
              search: '',
              tabSearchList: undefined,
              tabSelectList: item.exclusiveActivityAggregationPageDetailsSeriesEventVOS,
            };
          });
        }
      });
    },
    // 新增或编辑聚合页面
    updateOrAdd() {
      const copyForm = FunctionUtils.deepClone(this.form);

      if (this.id) {
        copyForm.exclusiveActivityAggregationPageAddSeriesEventDTOS = this.tabSearchs.map((item, index) => {
          return {
            id: index + 1,
            campaignId: Number(this.id),
            seriesName: copyForm.exclusiveActivityAggregationPageAddSeriesEventDTOS[index].seriesName,
            seriesSelectedImage: copyForm.exclusiveActivityAggregationPageAddSeriesEventDTOS[index].seriesSelectedImage,
            seriesUnselectedImage: copyForm.exclusiveActivityAggregationPageAddSeriesEventDTOS[index].seriesUnselectedImage,
            campaignSeriesEventId: item.tabSelectList.map(item => item.id) || [],
          };
        });
        updateAggregation(copyForm).then(res => {
          this.$message.success('编辑成功');
          this.$router.back(-1);
        });
      } else {
        copyForm.exclusiveActivityAggregationPageAddSeriesEventDTOS = this.tabSearchs.map((item, index) => {
          return {
            seriesName: copyForm.exclusiveActivityAggregationPageAddSeriesEventDTOS[index].seriesName,
            seriesSelectedImage: copyForm.exclusiveActivityAggregationPageAddSeriesEventDTOS[index].seriesSelectedImage,
            seriesUnselectedImage: copyForm.exclusiveActivityAggregationPageAddSeriesEventDTOS[index].seriesUnselectedImage,
            campaignSeriesEventId: item.tabSelectList.map(item => item.id) || [],
          };
        });
        addAggregation(copyForm).then(res => {
          this.$message.success('新增成功');
          this.$router.back(-1);
        });
      }
    },
    // 取消
    cancelBtn() {
      this.formDialogShow = true;
      this.information = {
        operation: 'cancel',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelTxt}，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.go(-1);
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.updateOrAdd();
          } else {
            return false;
          }
        });
      }
    },
  },
};

</script>
<style lang="less" scoped>
.aggregation-edit {
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
  .btns {
    align-items: center;
    justify-content: center;
  }
  .marginTop {
    margin-top: 30px;
  }
  :deep(.cotent-wrap) {
    .el-form-item__label {
      float: none;
    }
    .el-form-item__content {
      margin-top: 30px;
      margin-left: unset !important;
    }
  }
  .small-upload {
    :deep(.el-upload.el-upload--text) {
      width: 150px;
      height: 59px;
      .plus-push {
        width: 150px;
        height: 59px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  :deep(.search) {
    margin-top: 30px;
    display: flex;
    .el-input {
      width: 200px;
      margin-right: 20px;
    }
  }
  .spilt-title {
    margin: 30px 0;
    font-family: "Noto Sans SC";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
  .card-title {
    margin-bottom: 30px;
    font-family: "Noto Sans SC";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
    color: #494949;
  }
}
</style>
